import { ChangeDetectorRef, Component, ElementRef, OnInit, QueryList, ViewChildren, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { WebDokuTreeNode } from '../../models/webdoku-tree-node';
import { MatTreeNestedDataSource, MatTreeNode } from '@angular/material/tree';
import { NestedTreeControl } from '@angular/cdk/tree';

export type TreeNavigationValue = {id: string, displayedText: string}

@Component({
    selector: 'ldw-treenavigation-dialog',
    templateUrl: './tree-navigation-dialog.component.html',
    styleUrls: ['./tree-navigation-dialog.component.css'],
    standalone: false
})
export class TreeNavigationDialogComponent implements OnInit{
  dialogRef = inject<MatDialogRef<TreeNavigationDialogComponent>>(MatDialogRef);
  data = inject<{
    treeData: WebDokuTreeNode[];
    selectedValue: TreeNavigationValue;
    title: string;
}>(MAT_DIALOG_DATA);
  private changeDetectorRef = inject(ChangeDetectorRef);

  title!: string;
  message!: string;
  selectedValue: TreeNavigationValue
  treeControl = new NestedTreeControl<WebDokuTreeNode>(node => node.children);
  dataSource = new MatTreeNestedDataSource<WebDokuTreeNode>();
  @ViewChildren(MatTreeNode, { read: ElementRef }) treeElements : QueryList<ElementRef> | undefined

  constructor() {
    const data = this.data;

    this.dataSource.data = data.treeData;
    this.selectedValue = data.selectedValue;
  }

  ngOnInit() {
    if(this.selectedValue) {
      this.selectNode({id: this.selectedValue.id, text: this.selectedValue.displayedText, children: []})
      this.changeDetectorRef.detectChanges();
      this.treeElements?.find(element => element.nativeElement.hasAttribute('data-selected'))?.nativeElement.scrollIntoView()
    }
  }

  hasChild = (_: number, node: WebDokuTreeNode) => !!node.children && node.children.length > 0;

  isSelected(node: WebDokuTreeNode) {
    if (!node || !this.selectedValue) {
      return false;
    }
    return node.id == this.selectedValue.id;
  }

  selectNode(node: WebDokuTreeNode) {
    if (!node) {
      return;
    }

    const found = this.findNodeById(this.dataSource.data, node.id)
    if(found) {
      this.selectedValue = {id: node.id, displayedText: node.text}
    }
  }

  submit() {
    this.dialogRef.close(this.selectedValue);
  }

  cancel() {
    this.dialogRef.close(undefined);
  }

  private findNodeById(nodes: WebDokuTreeNode[], id: string): WebDokuTreeNode| void  {
     for (const node of nodes) {
      if(node.id === id) {
        return node
      } else {
        const result = this.findNodeById(node.children || [], id)
        if(result && node.children.length && !this.treeControl.isExpanded(node)) {
          this.treeControl.expand(node);
        }
        if(result) {
          return result;
        }
      }
    }
     return;
  }
}
